import { collection, doc, getDocs, getFirestore, query, setDoc, where } from 'firebase/firestore';
import { bigram } from 'n-gram';
import EmailTokenMap, { emailTokenMapConverter, EMAIL_TOKEN_MAP } from '../entities/EmailTokenMap';
import { SHOP } from '../entities/Shop';
import firebase from '../firebase/Firebase';

const store = getFirestore(firebase);

export const setEmailTokenMap = async (shopId: string, emailTokenMap: EmailTokenMap) => {
  const shopRef = doc(store, SHOP, shopId)
  const emailTokenMapDoc = doc(shopRef, EMAIL_TOKEN_MAP, emailTokenMap.id).withConverter(emailTokenMapConverter);
  return await setDoc(emailTokenMapDoc, emailTokenMap).catch((error) => {
    console.warn(error);
    return null
  });
}

export const searchEmailTokenMap = async (shopId: string, sentence: string) => {

  const searchWords = bigram(sentence)

  const shopRef = doc(store, SHOP, shopId)
  const mapCollection = collection(shopRef, EMAIL_TOKEN_MAP).withConverter(emailTokenMapConverter)
  const wheres = []
  searchWords.forEach((word) => {
    wheres.push(where(`map.${word}`, '==', true))
  })
  const q = query(mapCollection, ...wheres)
  return getDocs(q).then((snap) => {
    return snap.docs.map((doc) => doc.data())
  }).catch((err) => {
    return null
  });

}